import React from 'react';
import ReactDatePicker from 'react-datepicker';
import './style.scss';
// import 'react-datepicker/dist/react-datepicker.css';

const DatePicker = ({
  selectedDate,
  onChange,
  isClearable = false,
  showPopperArrow = true,
  customInput,
  ...props
}) => {
  return (
    <ReactDatePicker
      showYearDropdown
      selected={selectedDate}
      onChange={onChange}
      isClearable={isClearable}
      showPopperArrow={showPopperArrow}
      customInput={customInput}
      // popperPlacement="top-start"
      {...props}
    />
  );
};

export default DatePicker;
